module.exports = __webpack_public_path__ + "static/media/leaf-2.11c8fc7d.svg";